module.exports = __webpack_public_path__ + "img/mere32.18e28bfe.png";